import {Injectable} from '@angular/core';
import {FieldOfInterestPreview} from "../interfaces/field-of-interest-preview";
import {DataService} from "./data.service";
import {Observable, Subject, take, takeWhile} from "rxjs";
import {CheckboxFilterOption} from "../search-filter/checkbox-filter/checkbox-filter-option";
import {FieldOfInterest} from "../interfaces/field-of-interest";
import {SchoolSubjectsFilterItem} from "../search-filter/school-subjects-filter/school-subjects-filter-item";

@Injectable({
  providedIn: 'root'
})
export class InterestFieldsService {

  private interestFieldPreviews: FieldOfInterestPreview[] = [];
  private _interestFields = new Subject<FieldOfInterestPreview[]>();
  private interestFieldsLocalData: FieldOfInterest[] = [
    {id: 1, name: "", tag: "", icon: "SUBEJCT=Berufsfelder-Natur.svg", professionsNumber: -1, companiesNumber: -1, lottieSrc: "/assets/lottie-animations/interest_fields/Illu_Natur.json"},
    {id: 2, name: "", tag: "", icon: "SUBEJCT=Berufsfelder-Lebensmittel.svg", professionsNumber: -1, companiesNumber: -1, lottieSrc: "/assets/lottie-animations/interest_fields/Illu_Genuss.json"},
    {id: 3, name: "", tag: "", icon: "SUBEJCT=Berufsfelder-Kreativitaet.svg", professionsNumber: -1, companiesNumber: -1, lottieSrc: "/assets/lottie-animations/interest_fields/Illu_Kreativ.json"},
    {id: 4, name: "", tag: "", icon: "SUBEJCT=Berufsfelder-Bau.svg", professionsNumber: -1, companiesNumber: -1, lottieSrc: "/assets/lottie-animations/interest_fields/Illu_Bau.json"},
    {id: 5, name: "", tag: "", icon: "SUBEJCT=Berufsfelder-Unter-Strom.svg", professionsNumber: -1, companiesNumber: -1, lottieSrc: "/assets/lottie-animations/interest_fields/Illu_Strom.json"},
    {id: 6, name: "", tag: "", icon: "SUBEJCT=Berufsfelder-IT-Forschung.svg", professionsNumber: -1, companiesNumber: -1, lottieSrc: "/assets/lottie-animations/interest_fields/Illu_IT.json"},
    {id: 7, name: "", tag: "", icon: "SUBEJCT=Berufsfelder-Buero-Verwaltung.svg", professionsNumber: -1, companiesNumber: -1, lottieSrc: "/assets/lottie-animations/interest_fields/Illu_Buero.json"},
    {id: 8, name: "", tag: "", icon: "SUBEJCT=Berufsfelder-Medien-Kultur.svg", professionsNumber: -1, companiesNumber: -1, lottieSrc: "/assets/lottie-animations/interest_fields/Illu_Medien.json"},
    {id: 9, name: "", tag: "", icon: "SUBEJCT=Berufsfelder-Menschen.svg", professionsNumber: -1, companiesNumber: -1, lottieSrc: "/assets/lottie-animations/interest_fields/Illu_Menschen.json"}
  ];

  constructor(private dataService: DataService) {
    this.dataService.getAllInterestFields().pipe(take(1)).subscribe((val) => {
      if(val.length) {
        val = val.map((el) => {
          const target = this.interestFieldsLocalData.find((localEl) => localEl.id === el.id);
          if(target) {
            return {
              ...el,
              icon: target.icon
            }
          } else {
            return el;
          }

        })
        this.interestFieldPreviews = val;
        this._interestFields.next(val);
      }


    });
  }

  getLottieSrcByInterestFieldId(interestFieldId: number) {
    return this.interestFieldsLocalData.filter((localEl) => localEl.id == interestFieldId)[0].lottieSrc;
  }

  getAllFieldOfInterestPreviews(): Observable<FieldOfInterestPreview[]> {
    return new Observable<FieldOfInterestPreview[]>((observer) => {
      if(this.interestFieldPreviews.length) {
        observer.next(this.interestFieldPreviews);
        observer.complete();
      } else {
        this._interestFields.pipe(takeWhile((el) => el.length === 0, true))
          .subscribe((newVal) => {
            if(newVal.length) {
              this.interestFieldPreviews = newVal;
              observer.next(this.interestFieldPreviews);
              observer.complete();
            }
          });
      }
    })
  }

  getAllFieldOfInterests(): Observable<FieldOfInterest[]> {
    return new Observable<FieldOfInterest[]>((observer) => {
      this.getAllFieldOfInterestPreviews().pipe(take(1)).subscribe((interestFieldPreviews) => {
        const interestFields = this.interestFieldsLocalData.map((el) => {
          const preview = interestFieldPreviews.find((target) => target.id === el.id);
          if(preview) {
            return {
              ...el,
              ...preview
            }
          } else {
            return {
              ...el
            }
          }
        });

        observer.next(interestFields);
        observer.complete();

      });
    })
  }

  fieldOfInterestToFilterData(fields: FieldOfInterestPreview[]): SchoolSubjectsFilterItem[] {
    return fields.map((el) => {
      return {
        filterValue: el.id,
        icon: '/assets/img/field-of-interest-icons/' + el.icon,
        active: false,
        title: el.name
      }
    });
  }

  getFieldOfInterestNameById(id: number): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.getAllFieldOfInterestPreviews().pipe(take(1)).subscribe((val) => {
        let filteredFields = val.filter(field => {
          return field.id === id;
        });

        if(filteredFields.length) {
          resolve(filteredFields[0].name);
        } else {
          resolve("");
        }
      })
    })
  }

  getFieldOfInterestIconName(id: number): string {
    return this.interestFieldsLocalData.filter((field) => field.id === id)[0]?.icon ?? "";
  }

}
